import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { push } from "react-router-redux";
import { compose, lifecycle, withProps } from "recompose";
import { fetchApi } from "core/api/hoc";
import { candidate } from "routes/paths";
import { authenticated } from "modules/user/auth/hoc";
import { completedOnboarding, getWizardApi } from "../selectors";
import { getWizard } from "../api";

export default Component =>
  compose(
    authenticated,
    fetchApi(getWizard, {
      selector: getWizardApi,
      sync: true,
      key: "wizardApi"
    }),
    connect(
      createStructuredSelector({
        isCompleted: completedOnboarding
      }),
      {
        redirectToOnboarding: () => push(candidate.onboarding)
      }
    ),
    withProps(({ isCompleted, redirectToOnboarding, wizardApi }) => ({
      checkAccess() {
        if (!wizardApi.error && !isCompleted) {
          redirectToOnboarding();
        }
      }
    })),
    lifecycle({
      componentDidMount() {
        this.props.checkAccess();
      },
      componentDidUpdate() {
        this.props.checkAccess();
      }
    })
  )(
    ({ wizardApi, ...props }) =>
      !wizardApi.error && props.isCompleted ? <Component {...props} /> : null
  );



// WEBPACK FOOTER //
// ./src/modules/user/onboarding/hoc/onboarded.js